import { Box, Divider, Tab, Tabs } from '@mui/material';
import { Link as RouterLink, Outlet, useLocation } from '@tanstack/react-router';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from 'src/components/molecules/page-container';

export const Settings: FC = () => {
  const { t } = useTranslation(['settings']);

  const pathname = useLocation({ select: location => location.pathname });

  const tabs = [
    {
      href: `/settings/gdpr`,
      label: t('settings:gdpr.title'),
    },
    {
      href: `/settings/default-settings`,
      label: t('settings:default.title'),
    },
    {
      href: `/settings/logo`,
      label: t('settings:logo.title'),
    },
  ];

  const renderContent = () => {
    return (
      <>
        <Box>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
            }}>
            <Box sx={{ flexGrow: 1 }} />
          </Box>
          <Tabs
            allowScrollButtonsMobile
            sx={{ mt: 2 }}
            value={tabs.findIndex(tab => pathname.includes(`${tab.href}`))}
            variant="scrollable">
            {tabs.map(option => (
              <Tab component={RouterLink} key={option.href} label={option.label} to={option.href} />
            ))}
          </Tabs>
          <Divider />
        </Box>

        <Outlet />
      </>
    );
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1,
      }}>
      <PageContainer helmetPageTitle="Settings">
        <Box sx={{ height: '100%' }}>{renderContent()}</Box>
      </PageContainer>
    </Box>
  );
};
